import { ErrorMessageDefault } from '@/components/shared/components/ErrorBoundary/components/ErrorMessage/components/ErrorMessageFactory/exceptions/ErrorMessageDefault';
import { useTranslation } from '@/components/shared/hooks/useTranslation';
import es from '@/config/languages/es';

export const ErrorMessageException = ({ message }: { message: string }) => {
  const { getTextIdTranslation } = useTranslation();

  let displayMessage = message;

  try {
    const errorParsed = JSON.parse(JSON.parse(message));

    if (errorParsed?.message) {
      displayMessage = errorParsed?.message;
    }

    if (errorParsed?.error) {
      displayMessage = errorParsed?.error;
      displayMessage = getTextIdTranslation[displayMessage as keyof typeof es] ?? displayMessage;
    }

    if (errorParsed?.exception) {
      const exceptionPaths = errorParsed?.exception.split('\\');
      if (exceptionPaths?.length) {
        const exceptionName = exceptionPaths[exceptionPaths.length - 1];
        displayMessage = getTextIdTranslation[exceptionName as keyof typeof es] ?? exceptionName;
      }
    }
  } catch (e) {}

  return <ErrorMessageDefault message={displayMessage} />;
};
